(async () => {
  if (!cookieStore || typeof theme?.designer?.fetchDesignerAuth !== "function")
    return;
  const guestDesignsCookie = await cookieStore.get("guestDesigns");
  if (!guestDesignsCookie) return;
  if (typeof guestDesignsCookie?.value === "string") {
    try {
      const guestDesignIds = Object.values(
        JSON.parse(decodeURIComponent(guestDesignsCookie.value)),
      )
        .flatMap((a) => a)
        .map((a) => a.designId);
      if (guestDesignIds.length > 0) {
        const auth = await theme.designer.fetchDesignerAuth();
        if (typeof auth.token !== "string") return;
        const attachResp = await fetch(
          `https://api.jamplus.com/api/v1/designer/design/attach`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Bearer " + auth.token,
            },
            body: JSON.stringify({
              designIds: guestDesignIds,
            }),
          },
        );
        if (!attachResp.ok) return; // If the attach resp fails don't delete cookie. Try attach again later.
      }
      await cookieStore.delete("guestDesigns");
    } catch (e) {}
  } else {
    // Invalid cookie. Just delete it.
    await cookieStore.delete("guestDesigns");
  }
})();
